<template>
  <a
    class="pipeline-record"
    @click="openLeadModal(record.record_id)"
  >
    <p class="is-size-7 mb-25"
      v-if="record.status"
    >
      Status: {{ record.status }}
    </p>

    <template v-if="record.line_1 || record.city || record.state">
      <h3 class="is-size-6 has-text-weight-bold">
        {{ record.line_1 ? record.line_1 : 'Unknown Address' }}
      </h3>
      <p class="is-size-7 mt-25 mb-50">
        {{ record.city }}<span v-if="record.city && record.state">,</span>
        {{ record.state }}
      </p>
    </template>

    <template v-else>
      <h3 class="is-size-6 has-text-weight-bold mb-50">Unknown Address</h3>
    </template>

    <template v-if="record.full_name || record.phone_1 || record.phone_2">
      <p class="is-size-7 pipeline-record--contact">
        {{ record.full_name }}
        <span v-if="record.full_name && record.phone_1">|</span>
        {{ record.phone_1 }}
        <span v-if="record.phone_2">|</span>
        {{ record.phone_2 }}
      </p>
    </template>

    <template v-else>
      <p class="is-size-7">Unknown Contact</p>
    </template>
  </a>
</template>

<script>
export default {
  name: "PageHeaderSearchRecord",
  props: {
    record: {
      type: Object,
      required: true
    },
  },
  methods: {
    openLeadModal(id) {
      this.$router.replace({query: {lead: id}})
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/variables/variables";


.pipeline-record {
  position: relative;
  overflow: hidden;
  display: block;
  margin-bottom: 0.75rem;
  padding: 0.5rem 3.5rem 0.5rem 0.5rem;
  cursor: grab;
  transition: all 0.5s;
  box-shadow: 0 2px 3px rgba($dark, 0.1), 0 0 0 1px rgba($dark, 0.1);

  &:last-child {
    margin-bottom: 0;
  }

  &:link,
  &:visited {
    color: inherit;
  }

  &.is-warning {
    border-left-color: $yellow;
  }

  &.is-danger {
    border-left-color: $red;
  }

  &:hover {
    background: $grey-100;
  }

  &--contact {
    line-height: 1.3;
  }
}
</style>
